import DOMPurify from 'dompurify';

const EMPTY_ALLOCATION_PREVIEW_HTML = '<p></p>';

const ALLOCATION_PREVIEW_SANITIZE_OPTIONS: DOMPurify.Config = {
  FORBID_ATTR: ['style', 'color'],
  FORBID_TAGS: ['font'],
};

export const sanitizeAllocationPreviewHtml = (html: string): string =>
  DOMPurify.sanitize(html, ALLOCATION_PREVIEW_SANITIZE_OPTIONS);

export const normalizeAllocationPreviewHtml = (
  html: string | undefined | null,
): string | undefined => {
  const trimmed = html?.trim();

  if (!trimmed || trimmed === EMPTY_ALLOCATION_PREVIEW_HTML) {
    return undefined;
  }

  return trimmed;
};
